import React from 'react'
import {DatePicker} from "antd";

export function Datepicker({...props}){
    return (
        <DatePicker placeholder={'Selecione a data'} format={'DD/MM/YYYY'} {...props}/>
    )
}